import React from "react";
import { useHistory } from "react-router-dom";
import { Icon } from "@iconify/react";
import babyBottle from "@iconify-icons/emojione-monotone/baby-bottle";
import lineGraph from "@iconify-icons/gridicons/line-graph";
import babyIcon from "@iconify-icons/fa-solid/baby"; // npm install --save-dev @iconify/react @iconify-icons/openmoji
import openBook from "@iconify-icons/emojione-monotone/open-book";
import salineDrip from "@iconify-icons/openmoji/saline-drip";
import Header from "./Header";
import Footer from "./Footer";

import "./mainpage.css";

function MainPage() {
  let history = useHistory();

  var x = localStorage.setItem("gender","boy")
  //default value @growth gender
  
  const growth = () => {
    history.push("/growth");
    var x = localStorage.setItem("gender","boy")
  };

  const total = () => {
    history.push("/total");
  };

  const enteral = () => {
    history.push("/enteral");
  };

  const references = () => {
    history.push("/references");
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="main__page">
          <Header />
          <div className="select__word">
            <strong>Please select below</strong>
          </div>
          <div className="baby__setting">
            <Icon className="baby__icon" icon={babyIcon} />
          </div>
          <div className="growth__setting">
            <Icon icon={lineGraph} value = {x} className="growth__icon" onClick={growth} />
          </div>
          <div className="total__setting">
            <Icon className="total__icon" icon={salineDrip} onClick={total} />
          </div>
          <div className="icon__setting">
            <Icon
              icon={babyBottle}
              className="enteral__icon"
              onClick={enteral}
            />
          </div>
          <div className="book__setting">
            <Icon icon={openBook} className="book__icon" onClick={references} />
          </div>
        </div>
      </div>
     
    </div>
  );
}

export default MainPage;
